import clsx from 'clsx';
import { format } from 'date-fns';

type LabelDateProps = {
  date: string | Date;
  label?: string;
  className?: string;
  formatDate?: string;
  showTime?: boolean;
  timeFormat?: string;
  layout?: 'inline' | 'column';
};

export const LabelDate: React.FC<LabelDateProps> = ({
  date = new Date(),
  label,
  className,
  formatDate = 'yyyy-MM-dd',
  showTime = false,
  timeFormat = 'HH:mm:ss',
  layout = 'inline',
}) => {
  const parsedDate = new Date(date);
  const isValidDate = !isNaN(parsedDate.getTime());
  const fallbackDate = new Date();
  const displayDate = isValidDate ? parsedDate : fallbackDate;

  const datePart = format(displayDate, formatDate);
  const timePart = showTime ? format(displayDate, timeFormat) : '';

  if (layout === 'column') {
    return (
      <div className={clsx('flex flex-col items-center gap-0.5', className)}>
        <span className="text-mainText text-small">{datePart}</span>
        {timePart && (
          <span className="text-mainText text-small">{timePart}</span>
        )}
        {label && (
          <>
            <span className="font-bold">&#8226;</span>
            <span className="ml-sm">{label}</span>
          </>
        )}
      </div>
    );
  }

  return (
    <div className={clsx(className)}>
      <span className="mr-sm text-mainText text-small">{datePart}</span>
      {timePart && (
        <span className="mr-sm text-secondary text-tiny"> {timePart}</span>
      )}
      {label && (
        <>
          <span className="font-bold">&#8226;</span>
          <span className="ml-sm">{label}</span>
        </>
      )}
    </div>
  );
};
